import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Miles extends Lit3formBlock {
  static get characterName() {
    return 'miles';
  }

  static get characterProperties() {
    return {
      headerText: { type: String },
      descriptionText: { type: String },
      imagesArr: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  get cardsPerRow() {
    return this.content.cards_per_row || 'four';
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div
          class="${classMap({
            'block-grid': true,
            'miles-layout': true,
            'mobile-rows-1': this.oneRowNeeded,
            'mobile-rows-2': this.twoRowsNeeded,
            'mobile-rows-3': this.threeRowsNeeded,
          })}"
        >
          ${this.headerHTML} ${this.descriptionHTML}
          <div
            class="${classMap({
              images: true,
              'four-per-row': this.cardsPerRow === 'four',
              'six-per-row': this.cardsPerRow === 'six',
              'vertical-lines': this.verticalLineBreaks,
            })}"
          >
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    return this.headerStr
      ? html`
          <h2>${unsafeHTML(this.headerStr)}</h2>
        `
      : html``;
  }

  get descriptionHTML() {
    return this.descriptionStr
      ? html`
          <p class="description">${unsafeHTML(this.descriptionStr)}</p>
        `
      : html``;
  }

  imageHTML(image) {
    // Minimal card object: miles images are display-only, so no url /
    // full_resolution_src is passed and the card image stays unclickable.
    return html`
      <driver-card
        class="image-wrapper"
        .card=${{
          src: image.src,
          title: image.header,
          description: image.subheader || image.description,
        }}
        placement=${this.analyticsBlockLabel}
        image-width="320"
      ></driver-card>
    `;
  }

  get verticalLineBreaks() {
    return this.content.vertical_line_breaks == '1';
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionStr() {
    return this.withLineBreaks(this.content.description) || '';
  }

  get oneRowNeeded() {
    return this.mobileRowsNeeded === 1;
  }

  get twoRowsNeeded() {
    return this.mobileRowsNeeded === 2;
  }

  get threeRowsNeeded() {
    return this.mobileRowsNeeded === 3;
  }

  get mobileRowsNeeded() {
    let count = 0;
    if (!!this.content.header) count++;
    if (!!this.content.description) count++;
    if (!!this.imagesArr.length) count++;
    return count;
  }
}
Miles.defineElement();
